import { getBackgroundColor } from '../../util/getColorClassName.tsx';
import { fourCardsInRowCardGapPx, fourCardsInRowCardWidthPercentage, narrowColumnWidth, threeCardsInRowCardGapPx, threeCardsInRowCardWidthPercentage } from './constants.ts';
export const getImageCardImageContainerClasses = (contentDetailPage, imageBgColor) => {
    if (!!contentDetailPage.coverAboveTheGatedForm?.value) {
        return `flex shrink-0 h-[200px] ${getBackgroundColor(imageBgColor)} justify-center`;
    }
    if (contentDetailPage.thumbnailImage?.value) {
        return 'flex shrink-0 h-[200px]';
    }
    return 'flex shrink-0 h-[200px] justify-center items-center';
};
export const getImageCardImageClasses = (contentDetailPage) => {
    if (!!contentDetailPage.coverAboveTheGatedForm?.value) {
        return 'mt-[20px] mb-[-50px] w-[180px] overflow-hidden';
    }
    if (contentDetailPage.thumbnailImage?.value) {
        return 'flex grow-1 object-cover';
    }
    return 'flex shrink-1';
};
export const getImageCardImage = (contentDetailPage) => {
    if (!!contentDetailPage.coverAboveTheGatedForm?.expandedValue) {
        return mapToImgAndAlt(contentDetailPage.coverAboveTheGatedForm?.expandedValue, 'Cover');
    }
    if (contentDetailPage.thumbnailImage?.expandedValue) {
        return mapToImgAndAlt(contentDetailPage.thumbnailImage?.expandedValue, 'Thumbnail');
    }
    return getImagePlaceholder(contentDetailPage.referenceContentType?.value);
};
export const getImagePlaceholder = (referenceContentType) => {
    switch (referenceContentType) {
        case 'White Paper':
        default:
            return {
                src: '/images/content-managed/resourceType/whitePaper.svg',
                alt: referenceContentType
            };
    }
};
export const getCardTags = (contentDetailPage, displayType) => {
    const tags = contentDetailPage.tags?.value?.split?.(',') ?? [];
    switch (displayType) {
        case 'imageLabelCard':
            return tags?.slice?.(0, 2) || [];
        case 'labelCard':
            return tags;
        case 'logoCard':
        default:
            return undefined;
    }
};
export const getCardImage = (contentDetailPage, displayType) => {
    switch (displayType) {
        case 'imageLabelCard':
            return getImageCardImage(contentDetailPage);
        default:
        case 'labelCard':
            return undefined;
        case 'logoCard':
            return mapToImgAndAlt(contentDetailPage.logoImage?.expandedValue, 'Logo');
    }
};
export const getCardImageContainerClasses = (contentDetailPage, displayType, imageBgColor) => {
    switch (displayType) {
        case 'imageLabelCard':
            return getImageCardImageContainerClasses(contentDetailPage, imageBgColor);
        default:
        case 'labelCard':
            return '';
        case 'logoCard':
            return 'p-[30px] pb-0';
    }
};
export const getCardImageClasses = (contentDetailPage, displayType) => {
    switch (displayType) {
        case 'imageLabelCard':
            return getImageCardImageClasses(contentDetailPage);
        default:
        case 'labelCard':
            return '';
        case 'logoCard':
            return 'max-h-[40px] object-fill';
    }
};
export const calcCardWidth = (maxWidth, gapPx, widthPercentage) => {
    const elements = Math.floor(100 / widthPercentage);
    return Math.floor((maxWidth - gapPx * (elements - 1)) / elements);
};
export const getCardWidth = (width) => {
    switch (width) {
        case fourCardsInRowCardWidthPercentage.toString():
            return {
                elementWidth: calcCardWidth(narrowColumnWidth, fourCardsInRowCardGapPx, fourCardsInRowCardWidthPercentage),
                gap: fourCardsInRowCardGapPx
            };
        case threeCardsInRowCardWidthPercentage.toString():
        default:
            return {
                elementWidth: calcCardWidth(narrowColumnWidth, threeCardsInRowCardGapPx, threeCardsInRowCardWidthPercentage),
                gap: threeCardsInRowCardGapPx
            };
    }
};
const mapToImgAndAlt = (imgContentReference, fallbackAlt = '') => {
    return {
        src: imgContentReference?.url,
        alt: imgContentReference?.alt?.value ||
            imgContentReference?.name ||
            fallbackAlt
    };
};
